module.exports = __webpack_public_path__ + "img/azmi.8a047135.jpg";